import script from "./SecTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./SecTerminal.vue?vue&type=script&setup=true&lang=js"

import "./SecTerminal.vue?vue&type=style&index=0&id=31aedf20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31aedf20"]])

export default __exports__